export default {
  dataLogin: (state) => (data) => {
    return state.stateLogin
  },
  dataSesion: (state) => (data) => {
    return state.isSesionActive
  },
}